import { CSSProperties, useEffect, useRef, useState } from 'react'

import { PATH_NAME } from '@/config'
import { SWAP_FORM_ID } from '@/constants'
import { useQueryAccountCommissionSummary } from '@/data'
import { useBTCWallet } from '@/hooks'

import { Link, useLocation } from 'react-router-dom'

const nftImages = [
  {
    name: 'Ours',
    src: '/images/nft/Ours.png',
    class: 'z-[0] translate-y-[14px] rotate-[-4deg] w-[25%] ',
    zIndex: 0,
    bottom: 0,
    url: 'https://x.com/Optimexfi',
  },
  {
    name: 'W4ankie',
    src: '/images/nft/w4ankie.png',
    class: 'z-[1] translate-y-[10px] rotate-[10deg] w-[25%] ',
    zIndex: 1,
    bottom: 0,
    url: 'https://x.com/w4nkie',
  },
  {
    name: 'decentralized',
    src: '/images/nft/decentralized.png',
    class: 'z-[0] translate-y-[10px] w-[25%] ',
    zIndex: 0,
    bottom: 0,
    url: 'https://x.com/Decentralizd',
  },
  {
    name: 'Zac',
    src: '/images/nft/zac.png',
    class: 'z-[1] translate-y-[16px] rotate-[20deg] w-[25%] ',
    zIndex: 1,
    bottom: 0,
    url: 'https://x.com/zacxbt',
  },
  {
    name: 'Kuyamark',
    src: '/images/nft/kuyamark.png',
    class: 'z-[2] translate-y-[12px] w-[25%] ',
    zIndex: 2,
    bottom: 0,
    url: 'https://x.com/kuyamark',
  },
]

const bgImages = [
  {
    name: 'I love BTC',
    src: '/images/nft/i love btc.png',
    class: 'fixed  hidden md:block ',
    url: 'https://bitcoin.org/bitcoin.pdf',
  },
  {
    name: 'Hut',
    src: '/images/nft/hut.png',
    class: 'w-[200px]  bottom-0 fixed hidden md:block ',
    url: 'https://x.com/BitcoinPuppets',
  },
]

const ImageItem = ({
  src,
  url,
  class: className,
  name,
  style,
}: {
  src: string
  url: string
  class: string
  name: string
  style?: CSSProperties
}) => {
  return (
    <Link to={url} target='_blank' className={className} style={style}>
      <img src={src} alt={name} loading='lazy' />
    </Link>
  )
}

const isNft = false // bebug purpose only

export const NftBitcoin = () => {
  const btcWallet = useBTCWallet()
  const { data } = useQueryAccountCommissionSummary({
    walletAddress: btcWallet?.address,
  })
  const isNftHolder = data?.isNftHolders || isNft
  if (!isNftHolder) return null

  return (
    <div className='w-full mt-[-14px] md:pl-[24px] pl-[16px] overflow-hidden relative flex max-w-full justify-center mx-auto'>
      {nftImages.map((nft) => (
        <ImageItem
          key={nft.name}
          {...nft}
          class={`md:ml-[-34px] ml-[-20px] transition-transform duration-300 ${nft.class} hover:scale-[1.02]`}
        />
      ))}
    </div>
  )
}

export function NftTheme() {
  const [showBg, setShowBg] = useState(false)
  const node = useRef<HTMLElement | null>(null)
  const [heartStyle, setHeartStyle] = useState<CSSProperties>({})
  const [houseStyle, setHouseStyle] = useState<CSSProperties>({})

  const { pathname } = useLocation()

  const btcWallet = useBTCWallet()
  const { data } = useQueryAccountCommissionSummary({
    walletAddress: btcWallet?.address,
  })
  const isNftHolder = data?.isNftHolders || isNft

  useEffect(() => {
    const swapContainer = document.getElementById(SWAP_FORM_ID)
    if (swapContainer && window.innerWidth > 950) {
      node.current = swapContainer

      const { width, left } = swapContainer.getBoundingClientRect()
      const loveWidth = 220

      setHeartStyle({
        left: `${left / 2 - loveWidth / 2}px`,
        bottom: `${window.innerHeight * 0.3}px`,
        width: loveWidth,
      })
      setHouseStyle({ left: `${left + width + 12}px` })
      setShowBg(true)
    }
  }, [])

  const isWhitelistPath =
    [PATH_NAME.SWAP, PATH_NAME.FIXED_SWAP].some((e) => pathname.startsWith(e)) || pathname === PATH_NAME.HOME

  if (!isNftHolder || !showBg || !isWhitelistPath) return null

  return (
    <>
      <ImageItem {...bgImages[0]} style={heartStyle} />
      <ImageItem {...bgImages[1]} style={houseStyle} />
    </>
  )
}
